document.addEventListener('DOMContentLoaded', () => {
    const title = document.querySelector('.blog-hero__title');
    if (!title) return;
  
    const words = title.textContent.trim().split(/\s+/);
    title.innerHTML = '';
  
    words.forEach((word, idx) => {
      const span = document.createElement('span');
      span.className = 'word-fade';
      span.style.setProperty('--i', idx);
      span.textContent = word + (idx < words.length - 1 ? ' ' : '');
      title.appendChild(span);
    });
  
    title.classList.add('ready');
  });